var _path, _line, _line2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12L11.5 17L17 12",
    stroke: "#3CB4E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 5,
    x2: 11.5,
    y2: 17,
    stroke: "#3CB4E5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 17.5,
    x2: 17,
    y2: 17.5,
    stroke: "#3CB4E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundDownload);
export default __webpack_public_path__ + "static/media/roundDownload.f03429f60844bafe342865ea7bf1c378.svg";
export { ForwardRef as ReactComponent };